import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SurveyRespondentModel } from '../../../api/models/survey-respondent-model';
import { InviteLinkDispatchType } from '../../../enums/invite-link-dispatch-type';
import { QuestionnaireModel } from '../../../api/models/questionnaire-model';
import { QuestionnaireService } from '../../../api/services/questionnaire.service';
import { AuthService } from '../../../services/auth.service';
import { ScheduledQuestionnaireService } from '../../../api/services/scheduled-questionnaire';
import { ToastService } from '../../../services/toast.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-new-scheduled-questionnaire-modal',
  templateUrl: './new-scheduled-questionnaire-modal.component.html',
  standalone: false,
})
export class NewScheduledQuestionnaireModalComponent implements OnInit {
  dispatchType: InviteLinkDispatchType = InviteLinkDispatchType.Email;
  dispatchDate: string = new Date().toISOString().slice(0, 10);
  recipient: string = this.data.respondentDetails.email;
  questionnaires: QuestionnaireModel[] = [];
  questionnaireGuid?: string;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    public dialogRef: MatDialogRef<NewScheduledQuestionnaireModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      respondentDetails: SurveyRespondentModel;
      respondentGuid: string;
    },
    private questionnaireService: QuestionnaireService,
    private authService: AuthService,
    private scheduledQuestionnaireService: ScheduledQuestionnaireService,
    private toastService: ToastService,
  ) {}

  ngOnInit() {
    this.questionnaireService
      .questionnairesGet(this.authService.getAuthorisationHeaders(), {
        includeMainSurveysOnly: true,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (questionnaires: QuestionnaireModel[]) => {
          this.questionnaires = questionnaires;
          if (this.questionnaires.length > 0) {
            this.questionnaireGuid = this.questionnaires[0].guid;
          }
        },
      });
  }

  close() {
    this.dialogRef.close(false);
  }

  continue() {
    this.scheduledQuestionnaireService
      .scheduledQuestionnairesPost(this.authService.getAuthorisationHeaders(), {
        body: {
          questionnaireGuid: this.questionnaireGuid!,
          respondentGuid: this.data.respondentGuid,
          dispatchDateTime: this.dispatchDate,
          dispatchType: this.dispatchType,
        },
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.toastService.success('Survey scheduled successfully');
          this.dialogRef.close(true);
        },
      });
  }

  selectedQuestionnaireName() {
    return this.questionnaires.filter(
      (q) => q.guid === this.questionnaireGuid,
    )[0].name;
  }

  onDispatchTypeChanged() {
    if (this.dispatchType === InviteLinkDispatchType.Email) {
      this.recipient = this.data.respondentDetails.email;
    } else if (
      this.dispatchType === InviteLinkDispatchType.TextMessage &&
      this.data.respondentDetails.mobileNumber
    ) {
      this.recipient = this.data.respondentDetails.mobileNumber;
    }
  }

  protected readonly InviteLinkDispatchType = InviteLinkDispatchType;
}
